import { ReferralXlsxDto, Service } from 'common/api';
import { serviceRequest } from 'utils/http';

export function downloadXlsAPI(bodyRequest: ReferralXlsxDto) {
  return serviceRequest(() => Service.referralControllerDownloadXlsx(bodyRequest));
}
